import { graphql, useFragment } from 'react-relay';
import { defineMessages, useIntl } from 'dibs-react-intl';

import { type useSellerAwayCopy_seller$key } from './__generated__/useSellerAwayCopy_seller.graphql.ts';

const sellerFragment = graphql`
    fragment useSellerAwayCopy_seller on Seller {
        activeTimeAway {
            endDate
        }
    }
`;

const compactMessage = defineMessages({
    title: {
        id: 'bmc.SellerAwayCopy.title',
        defaultMessage: 'Seller is away until {endDate}',
    },
});

const regularMessage = defineMessages({
    title: {
        id: 'pdp.SellerAwayCopy.title',
        defaultMessage:
            'The seller is away until {endDate}. They are accepting orders but may be slower to respond.',
    },
});

export const useSellerAwayCopy = ({
    seller: sellerRef,
    messageType,
}: {
    seller: useSellerAwayCopy_seller$key | null | undefined;
    messageType: 'compact' | 'regular';
}): string | null => {
    const intl = useIntl();
    const seller = useFragment(sellerFragment, sellerRef);
    const { activeTimeAway } = seller || {};
    const { endDate } = activeTimeAway || {};

    if (!activeTimeAway || !endDate) {
        return null;
    }

    const message = messageType === 'regular' ? regularMessage : compactMessage;

    return intl.formatMessage(message.title, {
        endDate: intl.formatDate(endDate, { month: 'short', day: 'numeric', year: 'numeric' }),
    });
};
